export default __webpack_public_path__ + "static/media/galaxy_stars_bg_v2.4383aa17.jpg";